import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import Load from "./components/loading/load";
import ConfigurationManager from "./configuration/ConfigurationManager";

ConfigurationManager.environment = process.env;

//Create Context
export const I18nContext = createContext({});

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(null); // Default language
  const [translations, setTranslations] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const i18n = {
    T1: `Submit Job`,
    T2: `Jobs`,
    T3: `Art Assets`,
    T4: `Legacy Search`,
    T5: `Audit Report`,
    T6: ``,
    T7: `Product`,
    T8: `Packaging`,
    T9: `Marketing`,
    T10: `Publishing Plan`,
    T11: `Themed Entertainment`,
    T12: `Licensee Help`,
    T13: `Publisher Help`,
    T14: `Production Manager Help`,
    T15: `PD / BA Help`,
    T16: `Email Support`,
    T17: `<h3 style="color: red">** ATTENTION! **</h3>`,
    T18: `If having trouble submitting jobs to Star Labs, please register here to regain access.`,
    T19: `<strong>NEW TO 
<br />
STAR LABS? </strong>
<a>CLICK HERE</a>`,
    T20: `QUICK TIPS!`,
    T21: `DOWNLOAD ASSETS IN A FLASH`,
    T22: ``,
    T23: ``,
    T24: ``,
    T25: ``,
    T26: ``,
    T27: ``,
    T28: `<h4>
<strong>
STAR LABS is constantly updating. For more information and tips on how to use STAR LABS effectively, see our
<br />
<a>Help Section.</a>
</strong>
</h4>`,
    T29: `<a>
<strong class="blue">
Question? <u>Get in touch here</u>
</strong>
</a>`,
    T30: `GRAPHIC`,
    T31: `TRENDS`,
    T32: `<p class="text-center">
By using this site, you agree to the
<a>Privacy Policy</a>
and <a >Terms of Use</a>.
<br />
Note: Availability of guides is dependent on your licensing agreement. Some guides may not appear.
</p>`,
    T33: `BACK`,
    T34: `GO TO:`,
    T35: `ALL`,
    T36: `VIDEO SHOWCASE`,
    T37: `DC`,
    T38: `HARRY POTTER`,
    T39: `ANIMATION`,
    T40: `DISCOVERY`,
    T41: `LIVE ACTION/GAMING/OTHER`,
    T42: `VIDEO SHOWCASE`,
    T43: `DC`,
    T44: `HARRY POTTER`,
    T45: `ANIMATION`,
    T46: `DISCOVERY`,
    T47: `LIVE ACTION/GAMING/OTHER`,
    T48: `Product`,
    T49: `Licensee Name`,
    T50: `Contract`,
    T51: `Territories`,
    T52: `Select All`,
    T53: `Clear All`,
    T54: `Property`,
    T55: `Tier of Distribution`,
    T56: `Retailer`,
    T57: `Consumer Target`,
    T58: `Season`,
    T59: `On-shelf Date`,
    T60: `MM/DD/YYYY`,
    T61: ``,
    T62: `Project Description`,
    T63: `Linesheet Reference #`,
    T64: `Notes for BA Representative`,
    T65: `If applicable, please provide any additional context/notes about this submission for our review`,
    T66: `Associated Jobs`,
    T67: `Upload Line Sheet`,
    T68: `For Apparel and Accessories Only`,
    T69: ``,
    T70: ``,
    T71: ``,
    T72: ``,
    T73: ``,
    T74: ``,
    T75: ``,
    T76: `+Add Product`,
    T77: `Please ensure legal line is visible on submission.`,
    T78: `Add Design`,
    T79: `Licensee Internal Ref # / Manufacturer SKU`,
    T80: `Retailer SKU`,
    T81: `UPC`,
    T82: `Product Detail`,
    T83: `Original Asset Season`,
    T84: `Asset File Name`,
    T85: `You may begin typing in the field above to search for the STAR LABS Asset you are referencing for this submission. If you are not referencing a STAR LABS asset, you may search for and select "Licensee Reference Artwork."`,
    T86: `Characters`,
    T87: `Please note that the dropdown will only display the first 20 assets; in order to see additional assets, you will need to type and search the field for the STAR LABS assets you are looking for. If you cannot find the right characters for this submission, you may select "No Reportable Elements."`,
    T88: `Text/Verbiage on Product`,
    T89: `On-shelf Date`,
    T90: `MM/DD/YYYY`,
    T91: ``,
    T92: `Price Point (USD)`,
    T93: `Sold in package?`,
    T94: `Sold in set?`,
    T95: `Digital content?`,
    T96: `Plush?`,
    T97: `Please Note:`,
    T98: `<div>
 Design File uploads are limited to only <b>1</b> file. Supporting Materials are limited to <b>20</b> files.
</div>`,
    T99: `Please ensure legal line is visible on submission.`,
    T100: `Upload Design`,
    T101: `Upload Supporting Material`,
    T102: ``,
    T103: ``,
    T104: `Cancel`,
    T105: `Ok`,
    T106: `Licensee Ref #`,
    T107: `Retailer SKU`,
    T108: `UPC`,
    T109: `Product Detail`,
    T110: `Original Assets`,
    T111: `In-Market Date`,
    T112: `Cancel`,
    T113: `Submit`,
    T114: `Select the name of the licensee here`,
    T115: `Select the contract here`,
    T116: `Select which territories are involved`,
    T117: `Please select the property`,
    T118: `Please select the tier of distribution(s)`,
    T119: `Please select intended retailer(s).`,
    T120: `Please enter the target consumer for this package`,
    T121: `Please enter the season.`,
    T122: `Please enter the date the product being marketed will enter the markets`,
    T123: `Please enter a title for this packaging submission. E.G.; “Paid ads for our retail partner’s website” or “Influencer campaign for Back to School”`,
    T124: `Please enter valid linesheet reference`,
    T125: `Please provide additional context/notes about this submission for the BA team’s review`,
    T126: `Please include any additional package job #’s relevant to this submission`,
    T127: `Please, include the applicable Licensee Reference #`,
    T128: `Please, include the applicable Retailer SKU`,
    T129: `Please, include the applicable UPC as comma separated values`,
    T130: `Please, select the appropriate product detail for this submission`,
    T131: `Please, select the original asset seaons`,
    T132: `Please, include the file name of any assets used or referenced in this submission`,
    T133: `Please, list all characters included in this submission`,
    T134: `Please, include any relevant T&V from product for this submission`,
    T135: `Please, enter the date the product being marketed will enter the market`,
    T136: `Please, enter price point in USD`,
    T137: `Please, upload your design here`,
    T138: `No favourite jobs for {licenseeName}`,
    T139: `Click to edit submission name`,
    T140: `Loading...`,
    T141: `Save`,
    T142: `Submission added to favorites`,
    T143: `Upload any one design file is required to proceed`,
    T144: `Add at least one product to proceed`,
    T145: `{item} is required to proceed`,
    T146: `Price point should be a numeric value`,
    T147: `UPC should contain 12 numeric digits`,
    T148: `UPC is not valid`,
    T149: `UPC should be unique`,
    T150: `Please, use pencil icon to upload your design from the Add product`,
    T151: `Submitting your job, Please wait...`,
    T152: ``,
    T153: ``,
    T154: ``,
    T155: ``,
    T156: ``,
    T157: ``,
    T158: ``,
    T159: ``,
    T160: ``,
    T161: ``,
    T162: ``,
    T163: ``,
    T164: ``,
    T165: `Packaging`,
    T166: `Licensee Name`,
    T167: `Contract`,
    T168: `Territories`,
    T169: `Select All`,
    T170: `Clear All`,
    T171: `Property`,
    T172: `Tier of Distribution`,
    T173: `Retailer`,
    T174: `Consumer Target`,
    T175: `Season`,
    T176: `On-shelf Date`,
    T177: `MM/DD/YYYY`,
    T178: ``,
    T179: `Package Type`,
    T180: `If you cannot find the package type you are looking for, you may manually enter it in the "Notes for BA Representative" field below.`,
    T181: `Project Description`,
    T182: `Linesheet #`,
    T183: `Notes for BA Representative`,
    T184: `Associated Jobs`,
    T185: `Upload Line Sheet`,
    T186: `For Apparel and Accessories Only`,
    T187: ``,
    T188: `+Add Product`,
    T189: `Please ensure legal line is visible on submission.`,
    T190: `Add Design`,
    T191: `Licensee Internal Ref # / Manufacturer SKU`,
    T192: `Retailer SKU`,
    T193: `UPC`,
    T194: `Product Detail`,
    T195: `Original Asset Season`,
    T196: `Asset File Name`,
    T197: `You may begin typing in the field above to search for the STAR LABS Asset you are referencing for this submission. If you are not referencing a STAR LABS asset, you may search for and select "Licensee Reference Artwork."`,
    T198: `Characters`,
    T199: `Please note that the dropdown will only display the first 20 assets; in order to see additional assets, you will need to type and search the field for the STAR LABS assets you are looking for. If you cannot find the right characters for this submission, you may select "No Reportable Elements."`,
    T200: `Text/Verbiage on Product`,
    T201: `On-shelf Date`,
    T202: `MM/DD/YYYY`,
    T203: ``,
    T204: `Please Note:`,
    T205: `Design File uploads are limited to only 1 file. Supporting Materials are limited to 20 files.`,
    T206: `Please ensure legal line is visible on submission.`,
    T207: `Upload Design`,
    T208: `Upload Supporting Material`,
    T209: ``,
    T210: ``,
    T211: `Cancel`,
    T212: `Ok`,
    T213: `Licensee Ref #`,
    T214: `Retailer SKU`,
    T215: `UPC`,
    T216: `Product Detail`,
    T217: `Original Assets`,
    T218: `In-Market Date`,
    T219: `Cancel`,
    T220: `Submit`,
    T221: `Please enter the date the product being marketed will enter the market`,
    T222: `Please enter the package type for this package`,
    T223: ``,
    T224: `Upload any one design file is required to proceed`,
    T225: `Add at least one product to proceed`,
    T226: `is required to proceed`,
    T227: `Please, use pencil icon to upload your design from the Add product`,
    T228: ``,
    T229: ``,
    T230: ``,
    T231: ``,
    T232: ``,
    T233: ``,
    T234: ``,
    T235: ``,
    T236: ``,
    T237: ``,
    T238: ``,
    T239: ``,
    T240: ``,
    T241: ``,
    T242: `Marketing`,
    T243: `Licensee Name`,
    T244: `Contract`,
    T245: `Territories`,
    T246: `Select All`,
    T247: `Clear All`,
    T248: `Property`,
    T249: `Tier of Distribution`,
    T250: `Retailer`,
    T251: `Consumer Target`,
    T252: `Product On-shelf Date`,
    T253: `MM/DD/YYYY`,
    T254: ``,
    T255: `Marketing Channel`,
    T256: `Marketing Start Date`,
    T257: `MM/DD/YYYY`,
    T258: ``,
    T259: `Marketing End Date`,
    T260: `MM/DD/YYYY`,
    T261: ``,
    T262: `Campaign Title`,
    T263: `Context/Additional Notes`,
    T264: `Associated Jobs`,
    T265: `Licensee Ref #`,
    T266: `Who is your primary WBCP Business Contact? `,
    T267: `Product Detail`,
    T268: `Text/Verbiage on Product`,
    T269: `Please ensure legal line is visible.`,
    T270: `Upload Design`,
    T271: `Upload Supporting Material`,
    T272: `Please Note:`,
    T273: `Design File uploads are limited to only 1 file. Supporting Materials are limited to 20 files.`,
    T274: `Submit`,
    T275: `Please enter the date the product being marketed will enter the market`,
    T276: `Please select the marketing types and/or tactic(s)`,
    T277: `Please enter the date the marketing will go live`,
    T278: `Please enter the date, if applicable, the marketing will end`,
    T279: `Please enter a title for this marketing submission. E.G.; “Paid ads for our retail partner’s website” or “Influencer campaign for Back to School”`,
    T280: `Please provide additional context/notes about this submission for the marketing team’s review`,
    T281: `Please include the applicable Licensee Reference`,
    T282: `Who is your primary WBCP Business Contact?`,
    T283: `Please select the appropriate product detail for this submission`,
    T284: `Please list all characters included in this submission`,
    T285: `Please include any relevant T&V from product for this submission`,
    T286: `Done`,
    T287: `Delete`,
    T288: ``,
    T289: ``,
    T290: ``,
    T291: ``,
    T292: `Publishing Plan`,
    T293: `Licensee Name`,
    T294: `Contract`,
    T295: `Territories`,
    T296: `Select All`,
    T297: `Clear All`,
    T298: `Property`,
    T299: `Title`,
    T300: `Issue / Volume`,
    T301: `Notes for BA Representative`,
    T302: `Linesheet Reference #`,
    T303: `Associated Jobs`,
    T304: `+Add Product`,
    T305: `Add Design`,
    T306: `Licensee Internal Reference #`,
    T307: `Retailer SKU`,
    T308: `ISBN-10 / UPC`,
    T309: `ISBN-13`,
    T310: `Format`,
    T311: `Pickup?`,
    T312: `Asset File Name`,
    T313: `You may begin typing in the field above to search for the STAR LABS Asset you are referencing for this submission. If you are not referencing a STAR LABS asset, you may search for and select "Licensee Reference Artwork."`,
    T314: `Characters`,
    T315: `Please note that the dropdown will only display the first 20 assets; in order to see additional assets, you will need to type and search the field for the STAR LABS assets you are looking for. If you cannot find the right characters for this submission, you may select "No Reportable Elements."`,
    T316: `On Sale Date`,
    T317: `MM/DD/YYYY`,
    T318: ``,
    T319: `Cover Price`,
    T320: `Cancel`,
    T321: `Ok`,
    T322: `Licensee Internal Reference #`,
    T323: `Retailer SKU`,
    T324: `ISBN / UPC`,
    T325: `Format`,
    T326: `Asset File Name / Pickup Code`,
    T327: `On Sale Date`,
    T328: `Cancel`,
    T329: `Submit`,
    T330: `Please enter a title for this publishing submission`,
    T331: `Please enter the Volume`,
    T332: `Cover price should be a numeric value`,
    T333: `Please, use pencil icon to upload your design from the Add product`,
    T334: `Add at least one product to proceed`,
    T335: `is required to proceed`,
    T336: ``,
    T337: `Themed Entertainment`,
    T338: `Licensee Name`,
    T339: `Contract`,
    T340: `Territories`,
    T341: `Select All`,
    T342: `Clear All`,
    T343: `Property`,
    T344: `Submission Type`,
    T345: `Location`,
    T346: `Area`,
    T347: `Attraction`,
    T348: `Licensed Product Submission Number`,
    T349: `Consumer Target`,
    T350: `Project Description`,
    T351: `Linesheet Reference #`,
    T352: `Notes for BA Representative`,
    T353: `Associated Jobs`,
    T354: `Upload Line Sheet`,
    T355: `For Apparel and Accessories Only`,
    T356: ``,
    T357: `+Add Item`,
    T358: `Please ensure legal line is visible on submission.`,
    T359: `Add Design`,
    T360: `Licensee Internal Ref # / Manufacturer SKU`,
    T361: `Retailer SKU`,
    T362: `UPC`,
    T363: `Product Detail`,
    T364: `Original Asset Season`,
    T365: `Asset File Name`,
    T366: `You may begin typing in the field above to search for the STAR LABS Asset you are referencing for this submission. If you are not referencing a STAR LABS asset, you may search for and select "Licensee Reference Artwork."`,
    T367: `Characters`,
    T368: `Please note that the dropdown will only display the first 20 assets; in order to see additional assets, you will need to type and search the field for the STAR LABS assets you are looking for. If you cannot find the right characters for this submission, you may select "No Reportable Elements."`,
    T369: `Location`,
    T370: `Area`,
    T371: `Attraction`,
    T372: `Item`,
    T373: `Item Type`,
    T374: `Text/Verbiage on Product`,
    T375: `On-shelf Date`,
    T376: `MM/DD/YYYY`,
    T377: ``,
    T378: `Price Point (USD)`,
    T379: `Sold in package?`,
    T380: `Sold in set?`,
    T381: `Digital content?`,
    T382: `Plush?`,
    T383: `Please Note:`,
    T384: `Design File uploads are limited to only 1 file. Supporting Materials are limited to 20 files.`,
    T385: `Please ensure legal line is visible on submission.`,
    T386: `Upload Design`,
    T387: `Upload Supporting Material`,
    T388: ``,
    T389: ``,
    T390: `Cancel`,
    T391: `Ok`,
    T392: `Licensee Ref #`,
    T393: `Retailer SKU`,
    T394: `UPC`,
    T395: `Product Detail`,
    T396: `Original Assets`,
    T397: `In-Market Date`,
    T398: `Cancel`,
    T399: `Submit`,
    T400: `Select the name of the licensee here`,
    T401: `Select the contract here`,
    T402: `Select which territories are involved`,
    T403: `Please select the property`,
    T404: `Select the submission type here`,
    T405: `Please select the location`,
    T406: `Please select the area`,
    T407: `Please select the attraction`,
    T408: `enter submission number`,
    T409: `Please enter a title for this marketing submission. E.G.; “Paid ads for our retail partner’s website” or “Influencer campaign for Back to School”`,
    T410: `Please enter valid linesheet reference`,
    T411: `Please provide additional context/notes about this submission for the BA team’s review`,
    T412: `Please include any additional package job #’s relevant to this submission`,
    T413: `Please, include the applicable Licensee Reference #`,
    T414: `Please, include the applicable Retailer SKU`,
    T415: `Please, include the applicable UPC as comma separated values`,
    T416: `Please, select the appropriate product detail for this submission`,
    T417: `Please, select the original asset seaons`,
    T418: `Please, include the file name of any assets used or referenced in this submission`,
    T419: `Please, list all characters included in this submission`,
    T420: `Please, select the location`,
    T421: `Please, select the area`,
    T422: `Please, select the attraction`,
    T423: `Please, enter item`,
    T424: `Please, enter item type`,
    T425: `Please, include any relevant T&V from product for this submission`,
    T426: `Please, enter the date the product being marketed will enter the market`,
    T427: `Please, enter price point in USD`,
    T428: `Please, upload your design here`,
    T429: ``,
    T430: ``,
    T431: ``,
    T432: ``,
    T433: ``,
    T434: ``,
    T435: ``,
    T436: ``,
    T437: ``,
    T438: ``,
    T439: ``,
    T440: ``,
    T441: ``,
    T442: `Submission complete!`,
    T443: `Job ID:`,
    T444: `Home`,
    T445: `New Job Submission`,
    T446: `Don't forget to sign into Adobe to access jobs.`,
    T447: `<p>
If you do not see the popup, please click
<span class="link">HERE</span>
to regain access.
</p>
<p>`,
    T448: `OK`,
    T449: `Art Search`,
    T450: `Title Search`,
    T451: `Cart`,
    T452: `Add Selected to Cart`,
    T453: `Add All to Cart`,
    T454: `Art Search`,
    T455: `Search for something...`,
    T456: `Asset Search Help`,
    T457: `Brand`,
    T458: `Season`,
    T459: `Franchise / Property`,
    T460: `Style Guide`,
    T461: `Category/Theme`,
    T462: `Subcategory`,
    T463: `Character`,
    T464: `Language`,
    T465: `Clear`,
    T466: `Share`,
    T467: `Search`,
    T468: `Generated Share Link!`,
    T469: `Copy Link`,
    T470: `Link Copied`,
    T471: ``,
    T472: ``,
    T473: ``,
    T474: ``,
    T475: ``,
    T476: ``,
    T477: ``,
    T478: ``,
    T479: `Use search form on the left to view assets.`,
    T480: `{assetsCount} assets found`,
    T481: `Title`,
    T482: `Thumbnails`,
    T483: `Details`,
    T484: `Title`,
    T485: `Season`,
    T486: `Property`,
    T487: `Style Guide`,
    T488: `Character`,
    T489: `Art Category`,
    T490: ``,
    T491: ``,
    T492: ``,
    T493: ``,
    T494: ``,
    T495: ``,
    T496: `Columns Settings`,
    T497: `Title`,
    T498: `Season`,
    T499: `Property`,
    T500: `Style Guide`,
    T501: `Character`,
    T502: `Graphic Category`,
    T503: `Art Category`,
    T504: `Theme`,
    T505: `Language`,
    T506: `Subcategory`,
    T507: `Content Type`,
    T508: `Guideline Type`,
    T509: `WBCPAsset Type`,
    T510: `Modified`,
    T511: `Created`,
    T512: `Language`,
    T513: `Reset`,
    T514: `Close`,
    T515: `Back to results`,
    T516: `Asset Description`,
    T517: `Title`,
    T518: `Last Modified`,
    T519: `Style Guide`,
    T520: `Property`,
    T521: `Category/Theme`,
    T522: `Character`,
    T523: `Download Asset`,
    T524: `Restrictions`,
    T525: `Asset Description`,
    T526: ``,
    T527: ``,
    T528: ``,
    T529: ``,
    T530: ``,
    T531: ``,
    T532: ``,
    T533: ``,
    T534: ``,
    T535: ``,
    T536: `Preview`,
    T537: `Download`,
    T538: `RAPID DOWNLOAD`,
    T539: `Download Source`,
    T540: `This feature is currently unavailable.`,
    T541: `OK`,
    T542: `Must Agree to License to View this Asset.`,
    T543: `<p class="consent_notification_paragraph">
The asset you have chosen to view is highly sensitive and requires your consent prior to viewing.
</p>
<p class="consent_notification_paragraph">
To do so, please select "consent" to view the asset or cancel to go back to the previous page.
</p>`,
    T544: `Cancel`,
    T545: `Consent`,
    T546: `Must Agree to License to Download Asset`,
    T547: `<div class="dialog_main_note">
 <p>
 The asset you have chosen to download is highly sensitive and requires your consent prior to downloading.
 To do so, check the box next to the restriction below and select "submit".
 </p>
 
 <p>
 Use of any asset which goes against the restriction is prohibited and could be subject to penalties.
 </p>
</div>`,
    T548: ``,
    T549: `Cancel`,
    T550: `Submit`,
    T551: ``,
    T552: `Title Search`,
    T553: `Search for something...`,
    T554: `Asset Search Help`,
    T555: `Brand`,
    T556: `Franchise / Property`,
    T557: `Publisher`,
    T558: `Format`,
    T559: `Subformat`,
    T560: `Language`,
    T561: `Clear`,
    T562: `Share`,
    T563: `Search`,
    T564: `Generated Share Link!`,
    T565: `Copy Link`,
    T566: `Link Copied`,
    T567: `Title`,
    T568: `Last Modified`,
    T569: `Created`,
    T570: `Property`,
    T571: `Franchise / Brand`,
    T572: `Publisher`,
    T573: `Format`,
    T574: `WB Asset Id`,
    T575: `Pages`,
    T576: `Download Asset`,
    T577: `Download Book`,
    T578: `Asset Description`,
    T579: `Your Download Cart is empty.`,
    T580: `Cart Size:`,
    T581: `Web Download`,
    T582: `RAPID DOWNLOAD`,
    T583: `Clear All`,
    T584: `<div class="aspera-info">
 Rapid Download uses Aspera Connect |
 <span class="aspera-download-app">
 <a
 style="color: red"
 >Install Now</a>
 </span></div>`,
    T585: `Remove all assets from cart?`,
    T586: `This feature is currently unavailable.`,
    T587: `Must Agree to License to Download Asset(s)`,
    T588: `<div class="dialog_main_note">
<p>
Within the selection of assets you have chosen to download, one or more have restrictions which are important for you to review and accept prior to downloading. To do so, check the boxes next to each restriction above (if you already checked the boxes on the Cart screen, the boxes here will already be
checked).
</p>
<p>
To review the specific restriction on each asset in your download selection, click on the "Cancel" button below to go back to your Cart where there is a list view.
</p>
<p>
Use of any asset which goes against the listed restrictions is prohibited and could be subject to penalties.
</p>
</div>`,
    T589: ``,
    T590: `Cancel`,
    T591: `Submit`,
    T592: `Must Agree to License to Download Asset(s)`,
    T593: `<div class="dialog_main_note">
<p>
Within the selection of assets, you have chosen to download, one or more are highly sensitive that you must acknowledge understanding prior to downloading. To do so, check the boxes next to each restriction below and select "submit".
</p>

<p>
Use of any asset which goes against the restrictions is prohibited and could be subject to penalties.
</p>
</div>`,
    T594: `Cancel`,
    T595: `Submit`,
    T596: `Documents added to cart`,
    T597: `Preparing Zip export.`,
    T598: `Unauthorized`,
    T599: `You may not have the rights to edit this submission, please contact the STAR Labs Admin for support.`,
    T600: `Agree`,
    T601: `SKU`,
    T602: `SKU`,
    T603: `UPC`,
    T604: `UPC Should have 12 numeric digit
Multiple UPC can be provided seprated by commas
No duplicate UPC is allowed
For exmanple : 796030114977,026229781506`,
    T605: `Retailer`,
    T606: `Retailer`,
    T607: `Tier of Distribution`,
    T608: `Submit`,
    T609: `Print`,
    T610: `Show submission details`,
    T611: `Show Licensee comments`,
    T612: `Show documents`,
    T613: `Show proof comments`,
    T614: `The following information is required to access the PAR Form for Final Submission:

1. UPC or Retailer SKU
2. Tier of Distribution or Retailer`,
    T615: `Product Approval Form & Resubmission Form`,
    T616: `Warner Bros. Consumer Products`,
    T617: ``,
    T618: `Licensee to Complete:`,
    T619: `Date Sent to WBCP:`,
    T620: `Retail Season From:`,
    T621: `Retail Season From:`,
    T622: `Return form to licensee? Yes No`,
    T623: `Contract No:`,
    T624: `Licensee`,
    T625: `Contact`,
    T626: `Address`,
    T627: `Phone`,
    T628: `Territory`,
    T629: `Property`,
    T630: `Lic. Ref#`,
    T631: `CURRENT STATUS`,
    T632: ``,
    T633: `Do not proceed to a stage further than indicated above`,
    T634: `PRODUCT INFORMATION`,
    T635: `Product Detail`,
    T636: `Title`,
    T637: `Licensee Description:`,
    T638: `LEGAL NOTICE REQUIREMENTS`,
    T639: ``,
    T640: `Submitted via STAR Labs`,
    T641: `Initial Submission`,
    T642: `All comments and/or approvals are subject to the terms and conditions of the final executed license agreement between the two parties. No production/design approvals shall be deemed the approval of the use of any trademark, copyright or patent belonging to a third party. All comments given by the Warner Bros Consumer Products Brand Assurance Department in respect of designs and/or samples submitted, are provided on the express understanding that all costs incurred by you in creating and submitting designs and/or samples will be your sole responsibility and Warner Bros. Consumer Products will not be liable to you for any cost incurred by you in the creation or production of such designs and/or samples. You will also not retain any rights in and to any intellectual property owned or controlled by Warner Bros. Consumer Products through the creation of such designs and/or samples and you will not assume that a license has been granted in respect of any use of such intellectual property.`,
    T643: `Note: Normal Turnaround time is 10 business days, excluding weekends and holidays`,
    T644: `Licensee Help`,
    T645: ``,
    T646: `Training Guides, FAQs, & Job Aids`,
    T647: `Training Videos`,
    T648: `Submission Search`,
    T649: `TM Reporting`,
    T650: `Cart`,
    T651: `Loading...`,
    T652: `Legacy Archive Search`,
    T653: `Search for something...`,
    T654: `Search for something...`,
    T655: `Clear`,
    T656: `Search`,
    T657: `Application`,
    T658: `Art Program`,
    T659: `BA Rep`,
    T660: `Character`,
    T661: `Contract`,
    T662: `Job Category`,
    T663: `Job Id`,
    T664: `Job Last Status Date`,
    T665: `Job Stage Category`,
    T666: `Job Date Range`,
    T667: `Job Status`,
    T668: `Licensee Name`,
    T669: `LMSi Office`,
    T670: `Product Category Name`,
    T671: `Product Type Name`,
    T672: `Property Name`,
    T673: `Territory`,
    T674: `entries found.`,
    T675: `Add To Cart`,
    T676: `Select All`,
    T677: `Show as Table`,
    T678: `Show as Thumbnails`,
    T679: `Submission ID`,
    T680: `Submission Name`,
    T681: `Property Name`,
    T682: `Licensee Name`,
    T683: `Product Category Name`,
    T684: `Product Detail Name`,
    T685: `Product Category Name`,
    T686: `Product Category Name`,
    T687: `Product Category Name`,
    T688: `Back`,
    T689: `Last Modified`,
    T690: `Created`,
    T691: `Line of Business`,
    T692: `Contract`,
    T693: `Product Type Name`,
    T694: `LicenseeName`,
    T695: `Licensee Contact Name`,
    T696: `Property`,
    T697: `Territory`,
    T698: `BA Rep`,
    T699: `PD`,
    T700: `Description`,
    T701: `Title`,
    T702: `Job Status`,
    T703: `Retailer`,
    T704: `Job Start Date`,
    T705: `Character`,
    T706: `Job Last Status Date`,
    T707: `Products`,
    T708: `Bulk Download`,
    T709: `Download PAR Forms`,
    T710: `Download Job Histories`,
    T711: `Download Assets`,
    T712: `Application`,
    T713: `Submission Stage`,
    T714: `Submission Date`,
    T715: `Job Type`,
    T716: `Active`,
    T717: `Archived`,
    T718: `Active Search`,
    T719: `Search for something...`,
    T720: `Clear`,
    T721: `Search`,
    T722: `File Type`,
    T723: `BA Rep`,
    T724: `Character`,
    T725: `Coordinator`,
    T726: `Job Last Status Date`,
    T727: `Job Stage`,
    T728: `Job Date Range`,
    T729: `Job Status`,
    T730: `Job Type Stage`,
    T731: `Licensee Name`,
    T732: `LMSI Office`,
    T733: `Product Category Name`,
    T734: `Product Type Name`,
    T735: `Property Name`,
    T736: `Retailer`,
    T737: `Territory`,
    T738: `Job ID`,
    T739: `Submission ID`,
    T740: `File Name`,
    T741: `Property Name`,
    T742: `Licensee Name`,
    T743: `Product Category Name`,
    T744: `Product Detail Name`,
    T745: `Asset Information`,
    T746: `Source Application`,
    T747: `Live Classification`,
    T748: `Workfront Project Job ID`,
    T749: `STAR LABS Submission Title`,
    T750: `Submission Information`,
    T751: `Live Classification`,
    T752: `Workfront Project Job ID`,
    T753: `Product Category Name`,
    T754: `Product Type Name`,
    T755: `Product Detail Name`,
    T756: `Licensee Ref #`,
    T757: `LicenseeName`,
    T758: `Licensee E-Mail`,
    T759: `Licensee Contact Name`,
    T760: `Property Name`,
    T761: `Territory`,
    T762: `BA Rep`,
    T763: `Coordinator`,
    T764: `Retailer`,
    T765: `Job Stage`,
    T766: `Job Start Date`,
    T767: `Character`,
    T768: `Job Last Status Date`,
    T769: `BA Rep`,
    T770: `Archived Search`,
    T771: `Search for something...`,
    T772: `Clear`,
    T773: `Search`,
    T774: `File Type`,
    T775: `File Type`,
    T776: `Archive Submission Title`,
    T777: `File Version Type`,
    T778: `Submission ID`,
    T779: `Submission Date`,
    T780: `Line of Business`,
    T781: `Run Report`,
    T782: `Clear`,
    T783: `Download`,
    T784: `Cart Size:`,
    T785: `Download is in progress...`,
    T786: `Download Failed, please try again...`,
    T787: `Download has started...`,
    T788: `Download has started...`,
    T789: `Download is in progress...`,
    T790: `No Assets Found...`,
    T791: `No Assets Selected...`,
    T792: `Failed to retrive filters.`,
    T793: `Failed to retrive results.`,
    T794: `Failed to retrive asset.`,
    T795: `Failed to retrive submissions associated files.`,
    T796: `Audit Report`,
    T797: `Cart`,
    T798: `Asset Search`,
    T799: `Search for something...`,
    T800: `Character`,
    T801: `Franchise`,
    T802: `Property`,
    T803: `Style Guide Name`,
    T804: `entries found.`,
    T805: `Add To Cart`,
    T806: `RUN REPORT FOR ALL ASSETS`,
    T807: `Show as Table`,
    T808: `Show as Thumbnails`,
    T809: `Please confirm that you wish to run an audit report on 6 asset(s) with the following filter(s):`,
    T810: `Character:`,
    T811: `Select your date range`,
    T812: `Start Date`,
    T813: `End Date`,
    T814: ``,
    T815: `Character:`,
    T816: `Cancel`,
    T817: `Continue`,
    T818: `Thank you, your request is in process! Soon, you will receive a download link for your report on your STAR LABS registered e-mail.`,
    T819: `Close`,
    T820: `Title`,
    T821: `Style Guide`,
    T822: `Franchise/Property`,
    T823: `Loding...`,
    T824: `Processing...`,
    T825: `Run Report`,
    T826: `Clear`,
    T827: `Publisher Help`,
    T828: ``,
    T829: `Training Guides, FAQs, & Job Aids`,
    T830: `Training Videos`,
    T831: `Production Manager Help`,
    T832: ``,
    T833: `Training Guides, FAQs, & Job Aids`,
    T834: `<h3 style="color: #f580f5">
THE SS26 CREATIVE SHOWCASE IS NOW AVAILABLE!
</h3>`,
    T835: `S26 Creative Showcase Coming Soon`,
    T836: `The SS26 Creative Showcase will be available on 12/12/24!`,
    T837: `NOTICE: DEC. 5, 2024 IS THE DEADLINE FOR 2024 SUBMISSIONS`,
    T838: `Submissions received after this date will be reviewed in the new year
Chinese New Year starts on Jan. 25, 2025
Plan accordingly and get submissions in early to avoid the rush`,
    T839: `<h3 style="color: red">** ATTENTION! **</h3>`,
    T840: `THE FH26 CREATIVE SHOWCASE IS NOW AVAILABLE!`,
  };

  // Detect current browser language
  useEffect(() => {
    const browserLang = navigator.language || navigator.userLanguage;
    console.log("Browser language detected:", browserLang);
    if (browserLang.toLowerCase().startsWith("ja")) {
      setLang("ja-JP"); // For Japanese
    } else if (browserLang.toLowerCase().startsWith("zh-hk")) {
      setLang("zh-TW"); // For Traditional Chinese (Taiwan)
    } else if(browserLang.toLowerCase().startsWith("zh")) {
      setLang("zh-CN"); // For Simplified Chinese (China)
    }
     else {
      setLang("en-US"); // For English fallback
    }
  }, []);

  useEffect(() => {
    if (!lang) return;

    const fetchTranslations = async () => {
      setIsLoading(true);
      setError(null);
      const cacheKey = `appText-${lang}`;

      try {
        const cachedTranslations = sessionStorage.getItem(cacheKey);
        if (cachedTranslations) {
          console.log("Using cached translations for:", lang);
          setTranslations(JSON.parse(cachedTranslations));
          setIsLoading(false);
          return;
        }

        const apiUrl = ConfigurationManager.getProperty("TRANSLATION_API");
        // const apiUrl = `http://127.0.0.1:3000/stg2/actions/get-localized-translation`;

        if (!apiUrl) {
          console.error("TRANSLATION is not configured. Contact Support Team.");
        } else {
          const response = await axios.get(`${apiUrl}?lang=${lang}`);
          const newTranslations = response.data.translation || i18n;
          console.log("Translations fetched:", newTranslations);
          setTranslations(newTranslations);

          sessionStorage.setItem(cacheKey, JSON.stringify(newTranslations));
        }
      } catch (err) {
        console.error("Error fetching translations:", err);
        setError(err);
        setTranslations(i18n); // Fallback to default translations
      } finally {
        setIsLoading(false);
      }
    };

    fetchTranslations();
  }, [lang]);

  if (isLoading) {
    return <Load />;
  }
  return (
    <I18nContext.Provider value={translations}>{children}</I18nContext.Provider>
  );
};

// Custom hook (optional)
export const useI18n = () => useContext(I18nContext);
